export enum ServiceRequestStatusEnum {
  Created = 'Created',
  Open = 'Open',
  Accepted = 'Accepted',
  InProgress = 'In Progress',
  OnHold = 'On Hold',
  Closed = 'Closed',
  Declined = 'Declined',
  Cancelled = 'Cancelled',
  Complete = 'Complete',
}

export const OPEN_SERVICE_REQUEST_STATUSES: readonly ServiceRequestStatusEnum[] =
  [
    ServiceRequestStatusEnum.Created,
    ServiceRequestStatusEnum.Accepted,
    ServiceRequestStatusEnum.InProgress,
    ServiceRequestStatusEnum.OnHold,
  ];

export enum TaskStatusEnum {
  Created = 'Created',
  InProgress = 'In Progress',
  OnHold = 'On Hold',
  Withdrawn = 'Withdrawn',
  Completed = 'Completed',
  Expired = 'Expired',
}
